import { AssetDataAPI } from "../common/lib/API/AssetDataAPI";
import { ApplicationDataAPI } from "../common/lib/API/ApplicationDataAPI";
import { ChateauxAPI } from "../common/lib/API/Chateaux";

const AssetRepo = {
	async getApplicationAssetsById(app) {
		let assets = await ApplicationDataAPI.fetchApplicationAssetsById(
			app.id,
			app.broker_id
		);
		return assets;
	},
	async addAsset(data) {
		await AssetDataAPI.addAsset(data);
		return;
	},

	async updateAsset(data) {
		await AssetDataAPI.updateAsset(data);
		return;
	},
	async deleteAsset(assetId) {
		await AssetDataAPI.deleteAsset(assetId);
		return;
	},
	async getAssetDocuments(assetId) {
		await AssetDataAPI.getAssetDocuments(assetId);
		return;
	},
	async getAssetTypes(data) {
		let assetTypes = await AssetDataAPI.getAssetTypes(data);
		return assetTypes;
	},
	async getPriceDigestConfig(data) {
		let result = await ChateauxAPI.getPriceDigestConfig(data);
		return result;
	},
	async getEquipmentWatchConfig(data) {
		let result = await ChateauxAPI.getEquipmentWatchConfig(data);
		return result;
	},
	async getPriceDigestValue(data) {
		let result = await ChateauxAPI.getPriceDigestValue(data);
		return result;
	},
	async getEquipmentWatchValue(data) {
		let result = await ChateauxAPI.getEquipmentWatchValue(data);
		return result;
	},
};

export default AssetRepo;
